import React, { Component } from "react";
import LogsList from "../Components/LogsList/LogsList";
import { inject, observer } from "mobx-react";
import ButtonBack from "../Components/ButtonBack";

class LogsPage extends Component {
    constructor(props) {
        super(props);

        this.state = { logs: null, filteredLogs: null };
        this.onFilterChange = this.onFilterChange.bind(this);
    }

    componentDidMount() {
        this.fetchData();
    }

    async fetchData() {
        const { stores, customerId } = this.props;
        stores.data.LogsStore.fetchByCustomerId(customerId).then(() => {
            this.setState({ logs: stores.data.LogsStore._data });
        });
    }

    onFilterChange(e) {
        const filter = e.target.value;

        if (this.state.logs != null) {
            const filteredLogs = this.state.logs.filter(
                (l) =>
                    filter === "undefined" ||
                    !filter ||
                    (l.ApplicationVersion && l.ApplicationVersion.toLowerCase().indexOf(filter.toLowerCase()) !== -1) ||
                    (l.ApplicationName && l.ApplicationName.toLowerCase().indexOf(filter.toLowerCase()) !== -1) ||
                    (l.Date && l.Date.format("L LTS").toString().indexOf(filter.toLowerCase()) !== -1) ||
                    (l.IpAddress && l.IpAddress.toLowerCase().indexOf(filter.toLowerCase()) !== -1) ||
                    (l.UsedLogin && l.UsedLogin.toLowerCase().indexOf(filter.toLowerCase()) !== -1)
            );
            this.setState({ filteredLogs: filteredLogs });
        }
    }

    render() {
        let logs = this.state.logs;
        if (this.state.filteredLogs) logs = this.state.filteredLogs;

        return (
            <div>
                <div className="row">
                    <ButtonBack />
                </div>
                <div className="row">
                    <h1>Logs</h1>
                </div>
                <div className="row">
                    <div className="pull-left">
                        <input placeholder="Filter" className="form-control" onChange={this.onFilterChange} />
                    </div>
                    <div className="pull-right">
                        <p>(only 100 latest records)</p>
                    </div>
                </div>
                <div className="row">
                    <LogsList logs={logs} scrollable={false} />
                </div>
            </div>
        );
    }
}

export default inject("stores")(observer(LogsPage));



// WEBPACK FOOTER //
// ./src/Pages/LogsPage.js